import { json } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import button from "../../button.module.css"
import "./header.css";
import { END_POINTS } from "../../../services/endpoint/endPoint";
import authService from "../../../services/authServices";

const Header = ({isLogout, isSidebar}) => {
    const [showHideModal, setShowHideModal] = useState(false)
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword]=useState('')
    const [error, setError] = useState('')
    const user = JSON.parse(localStorage.getItem("user"));
    const user_name = user?.name;
    const fname = user?.name?.split('')[0];
    const user_logo = user?.user_logo || 'logo.svg';


    
    const logOut = () => {
        isLogout(false)
        localStorage.clear();
    }

    const toggleSidebar = () => {
        isSidebar();
    };

    const clickRestPassword = () => {
        setShowHideModal(!showHideModal)
        document.body.style = 'overflow: hidden'
    }

    const handleFormReset = () => {
        setShowHideModal(false)
        setNewPassword('')
        setConfirmPassword('')
        document?.body?.removeAttribute('style');
        
      }

      const handlePasswordReset = (e) => {
        let newpw = e.target.value
        setNewPassword(newpw)
        if ((confirmPassword !== newpw ) && confirmPassword !== '') {
            setError("Passwords do not match")
        } else {
            setError('')
        }
      }
    //   const validationPassword = () => {
    //     if (confirmPassword !== newPassword ) {
    //         setError("Passwords do not match")
    //     } else {
    //         setError('jkjk')
    //     }
        
    //   }
      const handleConfirmPassword = (e) => {
        let newConfirmPw = e.target.value
        setConfirmPassword(newConfirmPw)
        if ((newConfirmPw !== newPassword ) && newConfirmPw !== '') {
            setError("Passwords do not match")
        } else {
            setError('')
        }
      }

      const handelSubmit = (e) => {
        e.preventDefault()
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match!');
            return;
          }
        authService.login(END_POINTS.loggedInResetPassword, {token: user.token, password:newPassword, email :user?.email}).then((res) => {
            if(res.status === 200) {
                toast.success('Password reset successfully', {
                  position: "top-right"
                });
                document?.body?.removeAttribute('style');
                setShowHideModal(false)
            }
        })
        .catch((error)=> {
            console.log(" error in getting response ===>", error)
        })
      }
      
    return(
        <>
        <header className="d-flex justify-content-between">
            <div className="d-flex align-items-center">
            <div className="logo">
            {/* <img src={user_logo} /> */}
                    <img
                        src={user_logo}
                        alt="Partner Logo"
                        onError={(e) => {
                            e.target.src = `../../../assets/images/partner_img/tecreo.svg`;
                            e.target.alt = 'Image not available';
                        }}
                    />
              </div>
              
                <span className="header-toggle-icon" onClick={toggleSidebar}> &#9776; </span>
                {/* <i class="fa-solid fa-sliders header-toggle-icon" onClick={toggleSidebar}></i> */}
                {/* <div><h3>Manage Agency Partners</h3></div> */}

            </div>
            <ul className="header-list">
                <li className="list">
                    <div className="head-info">
                        <div className="user ">
                            {fname}
                        </div>
                        <div>
                            {/* <h6>{user_name} | <label>{user?.role}</label></h6> */}
                            <h6>{user_name}</h6>
                            
                        </div>
                        <div className="dropdown user-dropdown">
                            <i className="fa-solid fa-angle-down dropdown-toggle" data-bs-toggle="dropdown"></i>
                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item" onClick={clickRestPassword}><i className="fa-solid fa-key"></i>  Reset Password</a></li>
                                <li><hr className="dropdown-divider"/></li>
                                <li><a className="dropdown-item" onClick={logOut}><i className="fa-solid fa-arrow-right-from-bracket"></i>  Logout</a></li>
                                {/* <li><hr className="dropdown-divider"/></li>
                                <li><a className="dropdown-item" href="#">Logout</a></li> */}
                                </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </header>
        <div className={`modal form-modal ${showHideModal ? 'show' : ''}`}>
            <div className="modal-dialog modal-md">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Reset Password</h4>
                        <i className="fa-regular fa-circle-xmark close-icon" onClick={handleFormReset}></i>
                    </div>
                
                    <div className="modal-body">
                        <form onSubmit={handelSubmit}>
                            <div className="form-wraper">
                                <div className="form-group">
                                    <label>Email</label>
                                    <input type="text" value={user?.email} disabled={user?.email ? true : null}  className="form-control"/>
                                </div>
                                <div className="form-group">
                                    <label>New Password <span className="astric">*</span></label>
                                    <input type="password" placeholder="Enter New Password" value={newPassword.new_password} onChange={handlePasswordReset} name= "new_password"  className="form-control"/>
                                </div>
                                <div className="form-group">
                                    <label>Confirm Password <span className="astric">*</span></label>
                                    <input type="password" placeholder="Re Enter New Password" value={newPassword.confirmPassword} onChange={handleConfirmPassword} name= "confirmPassword"  className="form-control"/>
                                    {error && <div className="input-error">{error}</div>}
                                </div>
                                
                                <div className="text-end">
                                    <button type="submit" className={`${button.btn} ${button.btnBlue}`} >Reset</button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
        <div className={`${showHideModal ? 'overlay' : ''}`}></div>
        </>
    )
}

export default Header;